/**
 * Add-on entry point with configuration installers.
 *
 * @module index
 */
import type { ConfigType } from '@plone/registry';
import installRoutes from './config/routes';
import installSettings from './config/settings';
import installBlocks from './config/blocks';
import installViews from './config/views';
import installReducers from './config/reducers';
import './root.scss';

/**
 * Apply all configuration changes.
 *
 * @param config The Volto configuration registry.
 * @returns The same registry for chaining.
 */
function applyConfig(config: ConfigType) {
  installSettings(config);
  installBlocks(config);
  installViews(config);
  installReducers(config);
  installRoutes(config);

  return config;
}

export default applyConfig;

export type {
  LinkHref,
  ProfileBrain,
  ProfileContent,
  ProfileImage,
  SocialLink,
} from './types';
